module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/list-card/list-card.component.scss
// module id = ./src/app/shared/components/cards/list-card/list-card.component.scss
// module chunks = main